import React, { useState, useEffect, useRef } from 'react';
import ReactDOMServer from 'react-dom/server'
import { splitStringAtFirstOccurrence } from '@Utilities/StringUtils';

const MediaSection = (props) => {

    const handleFormUpdateForMedia = props.handleFormUpdateForMedia;
    var masterViewModel = props.masterViewModel;

    const initialRender = useRef(true);

    const [photoFormats, setPhotoFormats] = useState('');
    const [videoFormats, setVideoFormats] = useState('');
    const activeIntervals = useRef([]);
    var progressList = [];
    const currentPhotoCount = useRef(0);
    const currentVideoCount = useRef(0);
    const currentPhotoPlaceholderCount = useRef(0);
    const currentVideoPlaceholderCount = useRef(0);
    const sShowFileNameRef = useRef('');
    var isMediaSaveBusy = useRef(false);
    const [bShowPhotoMaxError, setbShowPhotoMaxError] = useState(false);
    const [bShowVideoMaxError, setbShowVideoMaxError] = useState(false);
    const [bShowFileSizeError, setbShowFileSizeError] = useState(false);
    const [bShowFileTypeError, setbShowFileTypeError] = useState(false);
    const [sShowFileTypeError, setsShowFileTypeError] = useState('');
    const [bShowFileUploadError, setbShowFileUploadError] = useState(false);
    const [sShowFileName, setsShowFileName] = useState('');

    const lstPhotoFormats = useRef([]);
    const lstVideoFormats = useRef([]);

    useEffect(() => {
        masterViewModel.validatorMedia = validatorMedia;
        handleFormUpdateForMedia(masterViewModel);

        var options = {
            photosortElementID: props.model.PhotoSortID,
            videosortElementID: props.model.VideoSortID,
            AppendTarget: $('#media')
        };

        var model = {
            MediaPurposes: "Listing Image,Listing Video",
            DisplayVideos: true
        };

        LoadMediaModal(model, options);

        setPhotoFormats($('#hfPhotoFormats').val().toString().replace(/,/g, ",."));
        setVideoFormats($('#hfVideoFormats').val().toString().replace(/,/g, ",."));
        lstPhotoFormats.current = $('#hfPhotoFormats').val().toString().replace(/,/g, ",.");
        lstVideoFormats.current = $('#hfVideoFormats').val().toString().replace(/,/g, ",.");

        let dropbox;
        dropbox = document.getElementById("dropbox");
        dropbox.addEventListener("dragenter", dragenter, false);
        dropbox.addEventListener("dragover", dragover, false);
        dropbox.addEventListener("drop", drop, false);

        //These translations don't happen in the media tool, so they're done after the media tool is loaded.
        $('#uploader_browse').html(ReactDOMServer.renderToString(getTranslation("AddFiles")));
        $('#uploader_selectfiles').html(ReactDOMServer.renderToString(getTranslation("SelectFiles")));
        $('#uploader_filename').html(ReactDOMServer.renderToString(getTranslation("Filename")));
        $('#uploader_size').html(ReactDOMServer.renderToString(getTranslation("Size")));
        $('#uploader_status').html(ReactDOMServer.renderToString(getTranslation("Status")));
    }, []);

    useEffect(() => {
        masterViewModel = props.masterViewModel;
    }, [props]);

    function uploadCompletedMethod(uploadedFile, response) {

        $("#uploader_filelist").show(); //onload the file list display is hidden

        let retries = 0;
        var awaitSave = setInterval(function () {
            retries++;
            if (isMediaSaveBusy.current == false || retries > 5000) {
                isMediaSaveBusy.current = true;
                retries = 0;
                clearInterval(awaitSave);
                //figure out the type of upload
                var type = "";
                var sFileExtension = uploadedFile.name.split(",")[0].split(".")[uploadedFile.name.split(",")[0].split(".").length - 1].toLowerCase();
                if (lstPhotoFormats.current.includes(sFileExtension)) {
                    type = "Picture";
                    $('.uploader-images').show();
                }
                else if (lstVideoFormats.current.includes(sFileExtension)) {
                    type = "Video";
                    $('.uploader-videos').show();
                }

                var photos = document.getElementById("sortablePhotos");
                var videos = document.getElementById("sortableVideos");

                //get the sort order form the elements displayed if they are not there assume it will be last(shouldn't happen).
                var photoSort = Array.from(photos.children).map((element) => element.getAttribute("mediaid"));
                var videoSort = Array.from(videos.children).map((element) => element.getAttribute("mediaid"));

                var sortOrder = 0;
                if (type == "Picture") {
                    const place = photoSort.indexOf(response.mediaId.toString());
                    sortOrder = place == -1 ? photoSort.length : place;
                }
                else if (type == "Video") {
                    const place = videoSort.indexOf(response.mediaId.toString());
                    sortOrder = place == -1 ? videoSort.length : place;
                }

                var objectToSave = [];
                var photoSort = [];
                var videoSort = [];
                var state = {
                    oObjectToSave: null,
                }

                objectToSave.push({
                    MediaID: response.mediaId,
                    OriginalName: uploadedFile.name,
                    SortOrder: sortOrder,
                    Type: type,
                    OldMediaID: "",
                });

                state.oObjectToSave = objectToSave;
                state.IsAdd = true;

                //save xml
                $.ajax({
                    type: "POST",
                    url: '/ListingInput/media/savexml' + props.model.QueryString,
                    data: JSON.stringify(state),
                    dataType: "json",
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    success: function (result) {
                        isMediaSaveBusy.current = false;
                    },
                    Error: function (result) {
                        isMediaSaveBusy.current = false;
                    }
                });
            }
        }, 150);
        document.getElementById("fileUpload-input").value = null;
    }

    function dragenter(e) {
        e.stopPropagation();
        e.preventDefault();
    }

    function dragover(e) {
        e.stopPropagation();
        e.preventDefault();
    }

    function drop(e) {
        e.stopPropagation();
        e.preventDefault();

        const dt = e.dataTransfer;
        const files = dt.files;

        uploadMedia(files);
    }

    function ReceiveMLPredictionCallback(predictionObject) {
        masterViewModel.MediaViewModel.MachineLearningPhotoData[predictionObject.mediaId] = {
            prediction: predictionObject.prediction
        };
        masterViewModel.ShowCookieModal = null; //need this to ensure the MediaSection doesn't reopen or hide the cookie consent modal
        handleFormUpdateForMedia(masterViewModel);
    }

    //handles all UI loader updating
    function handleUploadLoaderProgress(currentFile, progress, fileType) {
        var fileIndex = progressList.findIndex(obj => obj.name == currentFile.name);
        var progressTextSetInterval;
        var progressBarSetInterval;
        var maxProgressBeforeMedia = fileType == "video" ? 90 : 99;

        //only progress to this number until we get another update from the ajax event progress handler
        var maxProgressForCurrentGroup = progressList[fileIndex] != undefined ? (progressList[fileIndex].value * .9).toFixed(0) : maxProgressBeforeMedia;

        var groupInterval = 50;
        var progressNumInterval = 200;
        var mediaGroupInterval = 1000;

        if (progress == 0) {
            activeIntervals.current = (removeInactiveIntervals(activeIntervals.current, currentFile));
        }

        if (progress <= maxProgressBeforeMedia) {

            //interval for progress text
            progressTextSetInterval = setInterval(function () {
                renderProgress(currentFile.name, progress, progress, activeIntervals.current);
            }, progressNumInterval);

            //interval for progress bar
            progressBarSetInterval = setInterval(function () {
                if (progress > maxProgressForCurrentGroup || progress > maxProgressBeforeMedia) {
                    //stop updating, move onto new progress group
                    renderProgress(currentFile.name, progress - 1, progress - 1, activeIntervals.current);
                    activeIntervals.current = (Object.values(activeIntervals.current).filter(item => item.value != progressTextSetInterval));
                    clearInterval(progressTextSetInterval);
                    progressTextSetInterval = undefined;

                    activeIntervals.current = (Object.values(activeIntervals.current).filter(item => item.value != progressBarSetInterval));
                    clearInterval(progressBarSetInterval);
                    progressBarSetInterval = undefined;

                    handleUploadLoaderProgress(currentFile, progress, fileType);
                }
                else if (progress <= maxProgressForCurrentGroup && progress <= maxProgressBeforeMedia) {
                    renderProgress(currentFile.name, progress, 0, activeIntervals.current);
                    progress++;
                }
            }, groupInterval);

            activeIntervals.current = ([...activeIntervals.current, { value: progressTextSetInterval, name: currentFile.name }, { value: progressBarSetInterval, name: currentFile.name }]);
        }
        else if (progress > 90 && progress <= 99) {

            //interval for progress text and bar
            progressBarSetInterval = setInterval(function () {
                if (progress > 99) {
                    //stop updating, move onto new progress group
                    activeIntervals.current = (Object.values(activeIntervals.current).filter(item => item.value != progressBarSetInterval));
                    clearInterval(progressBarSetInterval);
                    progressBarSetInterval = undefined;

                    handleUploadLoaderProgress(currentFile, progress, fileType);
                }
                else if (progress <= 99) {
                    renderProgress(currentFile.name, progress, progress, activeIntervals.current);
                    progress++;
                }
            }, mediaGroupInterval);
        }
    }

    function uploadMedia(files) {   //called for every file upload attempt         
        var maxPhotoCount = 40;
        var maxVideoCount = 5;

        var photos = document.getElementById("sortablePhotos");
        var videos = document.getElementById("sortableVideos");

        currentPhotoCount.current = photos.children.length;
        currentVideoCount.current = videos.children.length;
        currentPhotoPlaceholderCount.current = currentPhotoCount.current;
        currentVideoPlaceholderCount.current = currentVideoCount.current;

        setbShowPhotoMaxError(false);
        setbShowVideoMaxError(false);
        setbShowFileSizeError(false);
        setbShowFileTypeError(false);
        setbShowFileUploadError(false);
        setsShowFileTypeError("");
        setsShowFileName("");
        sShowFileNameRef.current = "";

        for (let i = 0; i < files.length; i++) {
            if (files[i].size > 2147483648) {
                setbShowFileSizeError(true);
            }
            else {
                var sFileExtension = files[i].name.split(".").pop().toLowerCase();
                if (lstPhotoFormats.current.includes(sFileExtension) && currentPhotoPlaceholderCount.current < maxPhotoCount) {
                    //create placeholder box for loading progress
                    currentPhotoPlaceholderCount.current = currentPhotoPlaceholderCount.current + 1;
                    document.getElementById('sortablePhotos').appendChild(createProgressLoaderElement(files[i].name));
                    document.getElementsByClassName('uploader-images')[0].style.display = "block";
                }
                else if (lstVideoFormats.current.includes(sFileExtension) && currentVideoPlaceholderCount.current < maxVideoCount) {
                    //create placeholder box for loading progress
                    currentVideoPlaceholderCount.current = currentVideoPlaceholderCount.current + 1;
                    document.getElementById('sortableVideos').appendChild(createProgressLoaderElement(files[i].name));
                    document.getElementsByClassName('uploader-videos')[0].style.display = "block";
                }
            }
        }

        for (let i = 0; i < files.length; i++) {

            var fd = new FormData();
            var nextChunk = 0;
            var chunkSize = 2097152;
            if (files[i].size > 2147483648) {
                setbShowFileSizeError(true);
            }
            else {
                if (files[i].size > 2097152) {
                    chunkSize = 1048576; //if file is over 2MB, send it in 1MB chunks
                }
                var currentFile = files[i];
                var sFileExtension = currentFile.name.split(".").pop().toLowerCase();

                var fileType = (lstVideoFormats.current.includes(sFileExtension) ? "video" :
                    (lstPhotoFormats.current.includes(sFileExtension) ? "image" :
                        "invalid"));

                if (fileType == "invalid") {
                    if (bShowFileTypeError == true) {
                        setsShowFileTypeError(sShowFileTypeError + ", ." + currentFile.name.split(".").pop().toLowerCase());
                    }
                    else {
                        setbShowFileTypeError(true);
                        setsShowFileTypeError("." + currentFile.name.split(".").pop().toLowerCase());
                    }
                }
                else {
                    var totalChunks = Math.ceil(currentFile.size / chunkSize);
                    var bAsync = true;
                    fd.append("file", currentFile.slice(0, chunkSize)); //get first chunk

                    if ((fileType == "image" && currentPhotoCount.current < maxPhotoCount) || (fileType == "video" && currentVideoCount.current < maxVideoCount)) { // only upload if max isn't reached
                        if (fileType == "image") {
                            currentPhotoCount.current = currentPhotoCount.current + 1;
                        }
                        else {
                            currentVideoCount.current = currentVideoCount.current + 1;
                        }
                        progressList.push({ value: 0, currentChunk: nextChunk + 1, numChunks: totalChunks, name: currentFile.name });
                        startUpload(fd, files, currentFile, chunkSize, nextChunk, totalChunks, bAsync, fileType)
                    }
                }
            }
        }

        if (currentPhotoCount.current >= 40) {
            setbShowPhotoMaxError(true);
        }
        if (currentVideoCount.current >= 5) {
            setbShowVideoMaxError(true);
        }
    }

    function logUploadError(currentFile, status, chunk, totalChunks, chunkSize, textStatus) {
        if (status == 200) {
            return;
        }

        const chunkStart = chunk * chunkSize;
        const currentChunkSize = Math.min(chunkSize, Math.max(0, currentFile.size - chunkStart));
        $.ajax({
            type: "POST",
            url: '/listinginput/ajax/LogMessage',
            data: JSON.stringify({ 'sErrorMessage': `Media upload failed for ${currentFile.name} with HTTP status ${status}; reason=${textStatus || "unknown"}. Chunk index (0-based) ${chunk}; total chunks ${totalChunks}; chunk size ${currentChunkSize} bytes; file size ${currentFile.size} bytes.` }),
            dataType: "json",
            async: true,
            contentType: "application/json; charset=utf-8"
        });
    }

    function startUpload(fd, files, currentFile, chunkSize, nextChunk, totalChunks, bAsync, fileType) {
        handleUploadLoaderProgress(currentFile, 0, fileType);

        setTimeout(function () {
            $.ajax({
                type: "POST",
                url: `/listinginput/media/UploadMedia/?chunk=${nextChunk}&chunks=${totalChunks}&fileName=${currentFile.name}`,
                data: fd,
                datatype: 'json',
                async: bAsync,
                contentType: false,
                processData: false,
                success: function (result) {
                    let response = JSON.parse(result);
                    uploadMoreChunks(fd, files, currentFile, response, chunkSize, (nextChunk + 1), totalChunks, bAsync);
                },
                error: function (jqXHR, textStatus) {
                    logUploadError(currentFile, jqXHR.status, nextChunk, totalChunks, chunkSize, textStatus);
                    let response = {
                        message: "File upload failed",
                        mediamessage: "Media Upload threw an error for a photo/video."
                    };
                    //send error message to this function to show error on UI
                    uploadMoreChunks(fd, files, currentFile, response, chunkSize, (nextChunk + 1), totalChunks, bAsync);
                },
                xhr: function () {
                    // get the native XmlHttpRequest object                    
                    var xhr = $.ajaxSettings.xhr();
                    // set the onprogress event handler
                    xhr.upload.onprogress = function (evt) {
                        var fileIndex = progressList.findIndex(obj => obj.name == currentFile.name);
                        if (fileIndex > -1 && progressList[fileIndex] != undefined) {
                            progressList[fileIndex].value = (((evt.loaded / evt.total) * 100) / progressList[fileIndex].numChunks) * progressList[fileIndex].currentChunk;
                            progressList[fileIndex].currentChunk = nextChunk;
                        }
                    };
                    // return the customized object
                    return xhr;
                }
            });
        }, 50);
    }

    function uploadMoreChunks(fd, files, currentFile, response, chunkSize, nextChunk, totalChunks, bAsync) {
        if (response.message == "File Chunk Uploaded Correctly") {
            fd = new FormData();
            fd.append("file", currentFile.slice(nextChunk * chunkSize, ((nextChunk * chunkSize) + chunkSize))); //get next chunk

            $.ajax({
                type: "POST",
                url: `/listinginput/media/UploadMedia/?chunk=${nextChunk}&chunks=${totalChunks}&fileName=${currentFile.name}`,
                data: fd,
                datatype: 'json',
                async: bAsync,
                contentType: false,
                processData: false,
                success: function (result) {
                    var response = JSON.parse(result);
                    uploadMoreChunks(fd, files, currentFile, response, chunkSize, (nextChunk + 1), totalChunks, bAsync);
                },
                error: function (jqXHR, textStatus) {
                    logUploadError(currentFile, jqXHR.status, nextChunk, totalChunks, chunkSize, textStatus);
                    uploadMoreChunks(fd, files, currentFile, {
                        message: "File upload failed",
                        mediamessage: "Media Upload threw an error for a photo/video."
                    }, chunkSize, nextChunk + 1, totalChunks, bAsync);
                },
                xhr: function () {
                    // get the native XmlHttpRequest object
                    var xhr = $.ajaxSettings.xhr();
                    // set the onprogress event handler
                    xhr.upload.onprogress = function (evt) {
                        var fileIndex = progressList.findIndex(obj => obj.name == currentFile.name);
                        if (fileIndex > -1 && progressList[fileIndex] != undefined) {
                            progressList[fileIndex].value = (((evt.loaded / evt.total) * 100) / progressList[fileIndex].numChunks) * progressList[fileIndex].currentChunk;
                            progressList[fileIndex].currentChunk = nextChunk;
                        }
                    };
                    // return the customized object
                    return xhr;
                }
            });
        }
        else if (response.bSuccess === false || (response.message && response.message.includes("File upload failed"))) {
            removePlaceholderForFile(currentFile.name);
            activeIntervals.current = (removeInactiveIntervals(activeIntervals.current, currentFile));
            progressList = progressList.filter(obj => obj.name != currentFile.name);

            var photos = document.getElementById("sortablePhotos");
            var videos = document.getElementById("sortableVideos");
            if (photos?.children?.length == 0)
                $('.uploader-images').hide();
            if (videos?.children?.length == 0)
                $('.uploader-videos').hide();

            if (sShowFileNameRef.current == "") {
                sShowFileNameRef.current = currentFile.name.toString();
                setsShowFileName(currentFile.name);
            }
            else {
                var tempFileNames = sShowFileNameRef.current.toString();
                sShowFileNameRef.current = tempFileNames.toString() + ", " + currentFile.name.toString();
                setsShowFileName(tempFileNames.toString() + ", " + currentFile.name.toString());
            }
            setbShowFileUploadError(true);

            $.ajax({
                type: "POST",
                url: '/listinginput/ajax/LogMessage',
                data: JSON.stringify({ 'sErrorMessage': response.mediamessage || response.message }),
                dataType: "json",
                async: true,
                contentType: "application/json; charset=utf-8"
            });
        }
        else {
            progressList = progressList.filter(obj => obj.name != currentFile.name);
            var fileSortIDs = []
            for (let i = 0; i < files.length; i++) {
                fileSortIDs.push(files[i].name);
            }

            var sFileExtension = currentFile.name.split(".").pop().toLowerCase();
            if (lstPhotoFormats.current.includes(sFileExtension)) {
                //Images
                addInfoToLoaderElement(currentFile.name, response.mediaId, "");
                uploadCompletedMethod(currentFile, response);
                $('#sortablePhotos').sandhillsMediaInterface("fileAdded", response.mediaId + ".jpg", fileSortIDs, response.name);
                var isAttachment = props.masterViewModel.isAttachment;
                if (response.mlResult && !isAttachment) {
                    ReceiveMLPredictionCallback({
                        mediaId: response.mediaId,
                        prediction: response.mlResult,
                    });
                }
            }
            else if (lstVideoFormats.current.includes(sFileExtension)) {
                //Videos
                addInfoToLoaderElement(currentFile.name, response.mediaId, "");
                uploadCompletedMethod(currentFile, response);
                $('#sortableVideos').sandhillsMediaInterface("fileAdded", response.mediaId + ".mp4", fileSortIDs, response.name);
            }
        }
    }

    const getTranslation = (key) => {
        return props.masterViewModel.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: props.model.Translations[key] }}></span> :
            props.model.Translations[key];
    };

    const validatorMedia = (bButtonPress) => {
        var photos = document.getElementById("sortablePhotos");
        var bHasErrors = false;
        //Aircraft specific validation
        if (props.model.CurrentSite == "Aircraft" && photos?.children?.length < 1) {
            bHasErrors = true;
            $('#MediaErrorMessage').text("You must upload at least one photo");
            $('#MediaErrorMessage').show();
            ScrollToElement($('#MediaErrorMessage'));
        }
        else {
            $('#MediaErrorMessage').hide();
            if (!dataLayer_ContainsEvent(gTagEvents.addListingPhotos) && photos?.children?.length > 0) {
                window.dataLayer.push({
                    "event": gTagEvents.addListingPhotos
                });
            }

            var isAttachment = props.masterViewModel.isAttachment;
            if (bButtonPress && !isAttachment)
                props.GetMLData();

            SaveMediaInTheModal(true, bButtonPress);
            if (bButtonPress) {
                MediaSectionDone(props.masterViewModel.IsRearrangedDetailsPage, props.masterViewModel.IsAttachment, props.masterViewModel.IsLivestock, props.masterViewModel.IsCrop, props.model.CurrentSite);
            }
        }

        return !bHasErrors;
    };

    const getExpandedIntellectualPropertyDisclaimer = () => {
        if ($('#IntellectualPropertyDisclaimerPartTwo').css("display") == 'none') {
            $('#IntellectualPropertyDisclaimerPartTwo').show();
            $('#ExpandDisclaimerTxt').text(getTranslation("Less"));
        }
        else {
            $('#IntellectualPropertyDisclaimerPartTwo').hide();
            $('#ExpandDisclaimerTxt').text(getTranslation("More") + "...");
        }
    };

    let enhanceVisibilityTranslation = getTranslation("EnhanceVisibility");
    let enhanceVisibilitySplit = splitStringAtFirstOccurrence(enhanceVisibilityTranslation, ".");
    let firstPartOfEnhanceVisibility = enhanceVisibilitySplit.before;
    let boldedSectionOfEnhanceVisibility = enhanceVisibilitySplit.after;

    const fullMachineAndSNRecommended = masterViewModel.CurrentSite == "LivestockMarket" || masterViewModel.CurrentSite == "EquineMarket" || masterViewModel.CurrentSite == "BoatHarbor"
        ? null
        : getTranslation("FullMachineAndSNRecommended");

    return (
        <div className="accordion cf" id="accordion-content-1" style={{ paddingTop: '0px', display: props.masterViewModel.IsRearrangedDetailsPage ? 'none' : 'block' }}>
            <div id="media" className="">
                <div>
                    <div>
                        <p>{firstPartOfEnhanceVisibility} <strong>{boldedSectionOfEnhanceVisibility}</strong></p>
                    </div>

                    {/*new file upload UI*/}
                    <div style={{ textAlign: "center", fontSize: "15px", wordWrap: "break-word" }} className="validationError">
                        {bShowPhotoMaxError ? <p id="PhotoUploadError" style={{ display: "block" }}>{getTranslation("MaxPhotoUploadError")}</p> : null}
                        {bShowVideoMaxError ? <p id="VideoUploadError" style={{ display: "block" }}>{getTranslation("MaxVideoUploadError")}</p> : null}
                        {bShowFileSizeError ? <p id="FileSizeUploadError" style={{ display: "block" }}>{getTranslation("MaxFileSizeError")}</p> : null}
                        {bShowFileTypeError ? <p id="FileTypeUploadError" style={{ display: "block" }}>{getTranslation("FileTypeError")}: {sShowFileTypeError}</p> : null}
                        {bShowFileTypeError ? <p id="SupportedFileTypes" style={{ display: "block" }}>{getTranslation("SupportedFileTypes")}: {"." + photoFormats + ",." + videoFormats}</p> : null}
                        {bShowFileUploadError ? <p id="FileUploadError" style={{ display: "block" }}>{sShowFileName}: {getTranslation("FileUploadError")}</p> : null}
                    </div>
                    <label id="dropbox" className="media upload-box" tabIndex="0" onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            document.getElementById("fileUpload-input").click();
                        }
                    }}>
                        <input id="fileUpload-input"
                            accept={"." + photoFormats + ",." + videoFormats}
                            type="file"
                            multiple
                            onChange={(event) => { uploadMedia(event.target.files); }}
                        />
                        <strong>{getTranslation("DragOrClickToUpload")}</strong>
                        <span className="svg-container">
                            <svg className='fontawesomesvg' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                <path d="M256 0H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H552c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM64 128h96V384v32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V384H512v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16z" />
                            </svg>
                        </span>
                        {fullMachineAndSNRecommended}
                    </label>
                </div>
            </div>
            <div>
                <p>{getTranslation("IntellectualPropertyDisclaimerPartOne")}
                    &nbsp;<span id="IntellectualPropertyDisclaimerPartTwo" dangerouslySetInnerHTML={{ __html: getTranslation("IntellectualPropertyDisclaimerPartTwo") }} style={{ display: 'none' }}></span>
                    &nbsp;<button id="ExpandDisclaimerTxt" type="button" tabIndex="0" onClick={() => getExpandedIntellectualPropertyDisclaimer()} className="inLblLinkBlue">{getTranslation("More") + "..."}</button>
                </p>
                <br />
                {getTranslation("IntellectualPropertyDisclaimerPartThree")}
            </div>
            <button role="link" onClick={() => validatorMedia(true)} className="form-btn" id="equipment-btn">{getTranslation("DoneWithMedia")}</button>
        </div>
    );
};

export default MediaSection;
global.MediaSection = MediaSection;